<template>
  <div>
    <TopBar/>
    <div class="page-content">
      <div class="container">
        <div class="serach-area">
          <form>
            <div class="mb-3 input-group input-radius">
						  <span class="input-group-text">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M20.5605 18.4395L16.7528 14.6318C17.5395 13.446 18 12.0262 18 10.5C18 6.3645 14.6355 3 10.5 3C6.3645 3 3 6.3645 3 10.5C3 14.6355 6.3645 18 10.5 18C12.0262 18 13.446 17.5395 14.6318 16.7528L18.4395 20.5605C19.0245 21.1462 19.9755 21.1462 20.5605 20.5605C21.1462 19.9748 21.1462 19.0252 20.5605 18.4395ZM5.25 10.5C5.25 7.605 7.605 5.25 10.5 5.25C13.395 5.25 15.75 7.605 15.75 10.5C15.75 13.395 13.395 15.75 10.5 15.75C7.605 15.75 5.25 13.395 5.25 10.5Z" fill="#B9B9B9"/>
                </svg>
              </span>
              <input v-model="research" type="text" :placeholder="$t('product_search_placeholder')" class="form-control main-in ps-0 bs-0">
            </div>
          </form>
          <div class="swiper-btn-center-lr">
            <div class="swiper-container tag-group my-4 team-swiper-4">
              <div class="swiper-wrapper">
                <SubCategory v-for="category in subCategories" :setActive="setActive" :key="category.id" :id="category.id" :name="category.name" :active="activeCategory == category.id"/>
              </div>
            </div>
          </div>
        </div>
        <div class="dashboard-area">
          <div class="title-bar">
            <h5 class="title">Menu</h5>
          </div>
          <div v-if="loading" class="dz-spinner color-spinner">
            <div class="spinner-border spinner-sm me-2 mb-2 text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div v-else>
            <Menu v-for="menu in filteredMenus" :key="menu.id" :menu="menu"/>
            <p v-if="filteredMenus?.length == 0">{{$t('noData')}}</p>
          </div>
          <br><br>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, reactive, ref, watch} from "vue";
import TopBar from "@/views/master/layouts/partials/TopBar";
import Menu from "@/components/menu"
import SubCategory from "@/components/subcategory"
import {useStore} from "vuex";
import {useRoute} from "vue-router";

const store = useStore()
const route = useRoute()
const research = ref("")
const loading = ref(false)
const activeCategory = ref(null)
const menus = ref([])

onMounted(() => {
  store.dispatch('menu/loadCategories',restaurant_id.value)
  setDefaultActive()
  initSwipe()
})

const restaurant_id = computed(() => store.getters['restaurant/restaurant_id'])

const subCategories = computed(() => store.getters['menu/subCategories'](route.params?.id))
const filteredMenus = computed(() => {
  let search = research.value.toUpperCase()
  if(search && menus.value.length > 0){
    return menus.value.filter(menu => {
      let term = menu.name.toUpperCase() || menu.description.toUpperCase() || menu.price
      if(term.indexOf(search) != -1){
        return menu
      }
    })
  }else {
    return menus.value
  }
})

watch(() => subCategories.value, () => {
  if(subCategories.value.length > 0){
    activeCategory.value = subCategories.value[0]?.id
  }})

watch(() => activeCategory.value, () => {
  loadMeals()
})

function setActive(id){
  activeCategory.value = id
}

function setDefaultActive(){
  if(subCategories.value.length > 0){
    activeCategory.value = subCategories.value*[0]?.id
  }
}

function loadMeals(){
  loading.value = true
  store.dispatch('menu/loadCategoryMeals', {category:activeCategory.value, restaurant:restaurant_id.value}).then(response => {
    menus.value = response?.data?.meals
  }).finally(() => {
    loading.value = false
  })
}
function initSwipe(){
  // eslint-disable-next-line no-undef
  let swiper4 = new Swiper('.team-swiper-4', {
    speed: 1500,
    parallax: true,
    slidesPerView: 'auto',
    spaceBetween: 10,
    loop:false,
  });

  swiper4.init()
}

</script>

<style scoped>
.input-radius .form-control, .input-radius .input-group-text{
  border-radius: 10px;
}
.item-box .item-media img{
  height: 105px;
  width: 100%;
  object-fit: cover;
}
</style>